module.exports = __webpack_public_path__ + "static/media/pin_blue_highlighted.b917a70e.png";